import { lazy } from "react";

import Suspense from "components/shared/Suspense";
import { DrawerSettingsType } from "features/Drawer/types/types";
import useCurrentUserId from "hooks/user/useCurrentUserId";

const BookButtonOpen = lazy(() => import("../BookButtonOpen"));

export default function BookButtonDrawer({
  bookId,
  referrerUserId,
  settings,
}: {
  bookId: number;
  referrerUserId?: number;
  settings: DrawerSettingsType;
}) {
  const currentUserId = useCurrentUserId();

  // Never load or show the Book Button Drawer when not logged in
  if (!currentUserId) {
    return <></>;
  }

  return (
    <Suspense>
      <BookButtonOpen
        bookId={bookId}
        referrerUserId={referrerUserId}
        settings={settings}
      />
    </Suspense>
  );
}
